export enum MassiveNewRoutingSearchFlags {
  TEST_FLAG,
  CREATE_CEDI_MODAL,
  CONTINUE_TO_DELIVERIES
}
